<template>
    <span class="search-bar-with-regle">
        <div class="container">
            <input id="site-filter" class="site-input" v-model="filter" type="text" placeholder=" " required />
            <label class="label" for="site-filter">{{ $t('siteSelection.searchBar.placeHolder') }}</label>
            <img v-if="filter" class="icon" v-on:click="clear" :src="clearIcon" :alt="$t('alt.effacer.recherche')" />
        </div>
        <ReglePastille cle="demandeIntervention.rechercheSiteCritere" />
    </span>
</template>

<script lang="ts">
import { SITE_LIST } from '@/modules/SiteList/store/mutation-types';
import { SiteListActions } from '@/modules/SiteList/store/action-types';
import { defineComponent } from 'vue';
import { SiteSearchDTO } from '@/modules/SiteList/service/SiteListService';
import ReglePastille from '@/components/regles/ReglePastille.vue';

interface SearchBarData {
    debounce: number;
    localFilter: string;
}

export default defineComponent({
    components: {
        ReglePastille,
    },
    data(): SearchBarData {
        return { debounce: 0, localFilter: '' };
    },
    props: {
        unpaged: {type: Boolean, required: false},
        inclureTermines: {type: Boolean, required: false, default: false},
        siteListNamespace: {type: String, required: false, default: 'siteList'},
    },
    computed: {
        clearIcon() {
            return require('@/assets/img/close.svg');
        },
        filter: {
            get(): string {
                return this.localFilter;
            },
            set(value: any) {
                this.localFilter = value;
                this.$store.commit(`${this.siteListNamespace}/${SITE_LIST.SET_FILTER}`, value);
                clearTimeout(this.debounce);
                this.debounce = window.setTimeout(() => {
                    this.$emit('filter-change');
                    if (this.unpaged) {
                        this.$store.dispatch(`${this.siteListNamespace}/${SiteListActions.GET_SITE_LIST}`,
                            new SiteSearchDTO(0, this.localFilter, true, this.inclureTermines));
                    } else {
                        this.$store.dispatch(`${this.siteListNamespace}/${SiteListActions.GET_SITE_LIST}`,
                            new SiteSearchDTO(0, this.localFilter, false, this.inclureTermines));
                    }
                }, 600);
            },
        },
    },
    methods: {
        clear() {
            this.localFilter = '';
            this.$store.commit(`${this.siteListNamespace}/${SITE_LIST.SET_FILTER}`, '');
            this.$emit('filter-change');
            this.$store.dispatch(`${this.siteListNamespace}/${SiteListActions.GET_SITE_LIST}`, new SiteSearchDTO(0, '', false, this.inclureTermines));
        },
    },
});
</script>

<style scoped>
.search-bar-with-regle {
    display: flex;
    align-items: center;
    width: 100%;
}
.search-bar-with-regle .container {
    flex: 1;
}
.container {
    height: 16px;
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
}
.site-input {
    font-family: 'Roboto';
    border: none;
    outline: none;
    flex: 1;
    color: var(--black);
    order: 2;
}
.site-input:placeholder-shown:not(:focus) + .label {
    top: calc(50% - var(--font-size-low-medium) / 2);
    font-size: var(--font-size-low-medium);
}
.label {
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: -7px;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    font-size: var(--font-size-very-small);
    order: 1;
}
.icon {
    margin: 0;
    height: 24px;
    justify-self: end;
    cursor: pointer;
}
</style>
